__turbopack_context__.v({
  "actions": "sticky-nav-with-actions-module-scss-module__zlGSrq__actions",
  "container": "sticky-nav-with-actions-module-scss-module__zlGSrq__container",
  "layout": "sticky-nav-with-actions-module-scss-module__zlGSrq__layout",
  "legacyContainer": "sticky-nav-with-actions-module-scss-module__zlGSrq__legacyContainer",
  "newHeroContainer": "sticky-nav-with-actions-module-scss-module__zlGSrq__newHeroContainer",
  "tabs": "sticky-nav-with-actions-module-scss-module__zlGSrq__tabs",
});
